import { render, staticRenderFns } from "./ModalUpdateOrCreatePresale.vue?vue&type=template&id=8d20c9c2"
import script from "./ModalUpdateOrCreatePresale.vue?vue&type=script&lang=js"
export * from "./ModalUpdateOrCreatePresale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports